import axios from 'axios'


export const getArticle = (slug) =>
    axios.get(`articles/${slug}`)
        .then(({ data }) => data)
